import { render, staticRenderFns } from "./Listing.vue?vue&type=template&id=66163773&scoped=true"
import script from "./Listing.vue?vue&type=script&lang=js"
export * from "./Listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66163773",
  null
  
)

export default component.exports